import React, { useState, useEffect } from "react";
import { Widget, addResponseMessage } from "react-chat-widget";
import "react-chat-widget/lib/styles.css";

const defaultQuestion = {
  text: "Choose from the following options:",
  options: [
    "1. Book Appointment",
    "2. Private Lending",
    "3. Real Estate Transaction",
    "4. Wills",
    "5. Corporations",
  ],
};
const todoPrompt = {
  text: "Todo",
  options: ["1. Todo", "2. Go Back"],
  2: defaultQuestion,
};

const realEstatePrompt = {
  text: "Real Estate Transaction Options:",
  options: ["1. Purchasing", "2. Selling", "3. Refinancing", "4. Go Back"],
  1: todoPrompt,
  2: todoPrompt,
  3: todoPrompt,
  4: defaultQuestion,
};
const willsPrompt = {
  text: "Do you have an Existing Will?",
  options: ["1. Yes", "2. No", "3. Go Back"],
  1: todoPrompt,
  2: todoPrompt,
  3: defaultQuestion,
};
const corpPrompts = {
  text: "Do you have Existing Corporations?",
  options: ["1. Yes", "2. No", "3. Go Back"],
  1: todoPrompt,
  2: todoPrompt,
  3: defaultQuestion,
};

defaultQuestion["1"] = todoPrompt;
defaultQuestion["2"] = todoPrompt;
defaultQuestion["3"] = realEstatePrompt;
defaultQuestion["4"] = willsPrompt;
defaultQuestion["5"] = corpPrompts;

const Chat = () => {
  const [currentQuestion, setCurrentQuestion] = useState(defaultQuestion);
  //   const [currentOptions, setCurrentOptions] = useState(questions[defaultQuestion])

  useEffect(() => {
    const { text, options } = currentQuestion;
    addResponseMessage(text);
    const showOptions = options.join("\n");
    addResponseMessage(showOptions);
  }, [currentQuestion]);

  const handleNewUserMessage = (message) => {
    const nextQuestion = currentQuestion[message];
    if (nextQuestion && message !== "text" && message !== "options") {
      setCurrentQuestion(nextQuestion);
    } else {
      addResponseMessage("Response is not a recongized option");
    }
  };

  return (
    <Widget
      handleNewUserMessage={handleNewUserMessage}
      title="Virtual Assistant"
      subtitle="Choose an option!"
      senderPlaceHolder="Type a number..."
    />
  );
};

export default Chat;
